/**
 * @package Bears Elements VC
 * @author Bearsthemes
 */

import PriorityNav from 'priority-nav';
import FuryGrid from './modules/jquery.furygrid.js';

!(function(w, $) {
  'use strict';

  /**
   * modules
   */
  require('./modules/once');

  var BearsElementsVC = function () {

    /**
     * Visual Conposer Frontend Builder
     */
    this.FrontendBuilderApplyScript = function() {
      var _InterValLoop,
          self = this;

      _InterValLoop = setInterval(function() {
        self.OnceHandle();
      }, 500)
    }

    /**
     * Once handle
     */
    this.OnceHandle = function () {
      this.SlickCarousel();
      this.SlickFilter();
      this.FuryGrid();
      this.PriorityNav();
    }

    /**
     * Slick carousel
     */
    this.SlickCarousel = function () {
      $('*[data-bevc-slick]')._once(function() {
        var $thisEl = $(this),
            Clone = $thisEl.find('> *').clone(),
            options = $thisEl.data('bevc-slick'),
            opt_rows = options.rows;

        options.nextArrow = '<div class="custom-slick-next"><img src="'+ bevc_object.images.arrow_next +'" alt="'+ bevc_object.language.TEXT_NEXT +'"></div>';
        options.prevArrow = '<div class="custom-slick-prev"><img src="'+ bevc_object.images.arrow_prev +'" alt="'+ bevc_object.language.TEXT_PREV +'"></div>';
        
        // add slick slide
        var SlickObject = $thisEl.slick(options);

        var FilterEffect_Handle = {
          'slide-up': {
            hide (SlideItems) {
              var NumIncrease = 0;

              SlideItems.css('opacity', 0)
              .each(function() {
                $(this).css({
                  transition: 'opacity .5s cubic-bezier(.68,.12,.49,.88), transform .5s cubic-bezier(.68,.12,.49,.88)',
                  transform: 'translateY(20%)',
                  transitionDelay: 0.1 + NumIncrease * 0.1 + 's',
                })

                NumIncrease += 1;
              })
            },
            show (SlideItems) {
              SlideItems.css({
                opacity: 1,
                transform: 'translateY(0)',
              });
            }
          },
          'zoom-in': {
            hide (SlideItems) {
              var NumIncrease = 0;

              SlideItems.css('opacity', 0)
              .each(function() {
                $(this).css({
                  transition: 'opacity .5s cubic-bezier(.68,.12,.49,.88), transform .5s cubic-bezier(.68,.12,.49,.88)',
                  transform: 'scale(1.3)',
                  transitionDelay: 0.1 + NumIncrease * 0.1 + 's',
                })

                NumIncrease += 1;
              })
            },
            show (SlideItems) {
              SlideItems.css({
                opacity: 1,
                transform: 'scale(1)',
              });
            }
          },
          'zoom-out': {
            hide (SlideItems) {
              var NumIncrease = 0;

              SlideItems.css('opacity', 0)
              .each(function() {
                $(this).css({
                  transition: 'opacity .5s cubic-bezier(.68,.12,.49,.88), transform .5s cubic-bezier(.68,.12,.49,.88)',
                  transform: 'scale(.7)',
                  transitionDelay: 0.1 + NumIncrease * 0.1 + 's',
                })

                NumIncrease += 1;
              })
            },
            show (SlideItems) {
              SlideItems.css({
                opacity: 1,
                transform: 'scale(1)',
              });
            }
          },
        }
        
        // add slick filter
        $thisEl.on({
          '_count_item_by_class.bevc-slick-slide' (e, className) {
            return Clone.filter(className).length;
          },
          '_filter.bevc-slick-slide' (e, filter, effect) {
            var filterSlides = (filter == '*') ? Clone.clone() : Clone.filter(filter);

            // do effect hide
            (FilterEffect_Handle[effect]) ? FilterEffect_Handle[effect].hide(filterSlides) : '';
            
            // apply slick slide
            var NewOptions = function() {
              if(filter != '*') options.rows = 1
              else options.rows = opt_rows;
              return options;
            }
            
            SlickObject.slick('unslick').html('').append(filterSlides).slick(NewOptions());

            // do effect show
            (FilterEffect_Handle[effect]) ? FilterEffect_Handle[effect].show(filterSlides) : '';
            
          }
        })
      })
    }

    this.SlickFilter = function () {
      $('*[data-bevc-slick-has-filter]')._once(function() {
        var $thisEl = $(this),
            $NavEl = $thisEl.find('[data-bevc-slick-filter-nav]'),
            $SlickSlideEl = $thisEl.find('[data-bevc-slick]'); 

        var FitterEffectAvailable = ['slide-up', 'zoom-in', 'zoom-out'];
        var NavTotalNumber = $NavEl.data('nav-total-number');

        $NavEl.on({
          '_count.bevc-slick-has-filter' (e) {
            $(this).find('[data-bevc-filter-item]').each(function() {
              var number = $SlickSlideEl.triggerHandler('_count_item_by_class', [$(this).data('bevc-filter-name')]);
              
              $(this).append(`<span class="badge-count-number">${number}</span>`);
            })
          }
        })

        if(NavTotalNumber == 'show') { $NavEl.trigger('_count'); }

        $NavEl.on('click.bevc-slick-has-filter', '[data-bevc-filter-item]', function(e) {
          e.preventDefault();

          var FilterEffect = $NavEl.data('bevc-slick-filter-effect');

          if(FilterEffect == 'random') {
            FilterEffect = FitterEffectAvailable[Math.floor(Math.random() * FitterEffectAvailable.length)];
          }

          $SlickSlideEl.trigger('_filter', [$(this).data('bevc-filter-name'), FilterEffect]);

          $NavEl.find('._fillter-current').removeClass('_fillter-current');
          $(this).addClass('_fillter-current');
        })
        
      })
    }

    this.FuryGrid = function() {
      $('*[data-bevc-furygrid]')._once(function() {
        var $thisEl = $(this),
            opts = $.extend({
              El        : this,
              Col 			: 4,
			        Space 		: 24,
            }, $thisEl.data('bevc-furygrid'));
        
        if($thisEl.data('bevc-furygrid-col')) opts.Col = $thisEl.data('bevc-furygrid-col')
        if($thisEl.data('bevc-furygrid-space')) opts.Col = $thisEl.data('bevc-furygrid-space')

        new FuryGrid(opts);
      })
    }

    this.PriorityNav = function () {
      $('*[data-bevc-priority-navigation]')._once(function() {  
        var $thisEl = $(this),
            randClass = 'bevc-element-rand-item-' + Math.random().toString(36).substring(7);
        
        // add rand class
        $thisEl.addClass(randClass);

        var params = $.extend({
          mainNavWrapper: '.' + randClass, // mainnav wrapper selector (must be direct parent from mainNav)
          mainNav: '[data-main-nav]', // mainnav selector. (must be inline-block)
          navDropdownLabel: bevc_object.language.TEXT_MORE,
          navDropdownBreakpointLabel: bevc_object.language.TEXT_FILTER,
          navDropdownClassName: "nav__dropdown", // class used for the dropdown.
          navDropdownToggleClassName: "nav__dropdown-toggle", // class used for the dropdown toggle.
        }, {
          navDropdownLabel: ($thisEl.data('nav-dropdown-label')) ? $thisEl.data('nav-dropdown-label') : bevc_object.language.TEXT_MORE,
          navDropdownBreakpointLabel: ($thisEl.data('nav-dropdown-breakpoint-label')) ? $thisEl.data('nav-dropdown-breakpoint-label') : bevc_object.language.TEXT_FILTER,
          navDropdownClassName: ($thisEl.data('nav-dropdown-class-name')) ? $thisEl.data('nav-dropdown-class-name') : "nav__dropdown",
          navDropdownToggleClassName: ($thisEl.data('nav-dropdown-toggle-class-name')) ? $thisEl.data('nav-dropdown-toggle-class-name') : "nav__dropdown-toggle",
        })

        PriorityNav.init(params);
      })
    }

    return this;
  }

  w.BearsElementsVC = w.BearsElementsVC || new BearsElementsVC();

  /** */
  function BEVC_Fix_Row_Stretch() {
    setTimeout(function() {$(w).trigger('resize');}, 100)
  }

  /* DOM Ready */
  $(function() {
    // console.log(bevc_object);
    // call OnceHandle
    w.BearsElementsVC.OnceHandle();

    // fix vc row stretch
    BEVC_Fix_Row_Stretch();
  })

  /* Browser load complete */
  $(w).load(function() {

  })

})(window, jQuery)



//////////////////
// WEBPACK FOOTER
// ./bears-elements-vc.js
// module id = 6
// module chunks = 0